import { Block } from '@chameleoncreator/creator-app';

export interface InteractionStyle {
  background?: string;
  foreground?: string;
  buttonBackground?: string;
  buttonForeground?: string;
}

export interface InteractionProps {
  name: string;
  columnCount: number;
  columnsReversed: boolean;
  style: InteractionStyle;
}

export const reverse = <T = any>(a: T, b: T, reversed: boolean): [T, T] => {
  return reversed ? [a, b] : [b, a];
};

export const repeat = (a: () => Block, count: number): Block[] => {
  return Array.from(Array(count)).map(a);
};
